const REDUCER = "@OTHERLINK/";

const actions = {
  GET_LIST_LINK: `${REDUCER}GET_LIST_LINK`,
  SET_LIST_LINK: `${REDUCER}SET_LIST_LINK`,
  SET_IS_LOADING: `${REDUCER}SET_IS_LOADING`,
  SET_CURRENT_LINK: `${REDUCER}SET_CURRENT_LINK`,
};
export default actions;
